// extracted by mini-css-extract-plugin
module.exports = {"gwMediaSidebarWrapper":"MediaSideBar_gwMediaSidebarWrapper__0-try","player":"MediaSideBar_player__jrhDH"};